import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthPrincipal } from './hooks/useAuthPrincipal';
import { isClientAuthDebug, clientAuthLog } from './lib/debug';

/** Minimal placeholder while Clerk resolves the session — not a content skeleton. */
function AuthResolvingSpinner() {
	return (
		<div role="status" aria-label="Loading" className="flex h-screen items-center justify-center text-content-tertiary">
			<div className="h-6 w-6 animate-spin rounded-full border-2 border-current border-t-transparent" />
		</div>
	);
}

/**
 * Route element that gates the authenticated tree. Child routes render through
 * <Outlet /> only once the principal is ready; React Router does not construct
 * child route elements until then, so no effect or query below this route can
 * fire (and 401) for a resolving or signed-out visitor.
 */
export default function RequireAuth() {
	const location = useLocation();
	const { status } = useAuthPrincipal();

	if (status === 'resolving') return <AuthResolvingSpinner />;

	if (status === 'signed-out') {
		if (isClientAuthDebug()) clientAuthLog('require_auth_redirect', { from: location.pathname });
		return <Navigate to="/sign-in" replace state={{ from: location }} />;
	}

	return <Outlet />;
}
